import { render, staticRenderFns } from "./nature.vue?vue&type=template&id=3aad0e02&"
import script from "./nature.vue?vue&type=script&lang=js&"
export * from "./nature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports